const Profil = {

    init() {

        this.el = $('[component="Profil"]');

        if (!this.el.length) {
            return;
        }

        this.bind();
    },

    bind() {
    },

}
export default Profil;